export default class CookieNotice {
  constructor ($el) {
    this.$el = $el
    this.$button = $el.find('.js-cookie-notice__close')
    this.addEventHandlers()
  }

  addEventHandlers () {
    this.$button.click(this.onClick.bind(this))
  }

  onClick () {
    document.cookie = 'cookie_notice_seen=true; expires=Fri, 31 Dec 3017 23:59:59 GMT; path=/'
    this.$el.remove()
    return false
  }
}

$(() => {
  $('.js-cookie-notice').map(function () {
    new CookieNotice($(this))
  })
})
